/*!
	Colorbox 1.6.4
	license: MIT
	http://www.jacklmoore.com/colorbox
*/
(function ($, document, window) {
	var
	// Default settings object.
	// See http://jacklmoore.com/colorbox for details.
	defaults = {
		// data sources
		html: false,
		photo: false,
		iframe: false,
		inline: false,

		// behavior and appearance
		transition: "elastic",
		speed: 300,
		fadeOut: 300,
		width: false,
		initialWidth: "600",
		innerWidth: false,
		maxWidth: false,
		height: false,
		initialHeight: "450",
		innerHeight: false,
		maxHeight: false,
		scalePhotos: true,
		scrolling: true,
		opacity: 0.9,
		preloading: true,
		className: false,
		overlayClose: true,
		escKey: true,
		arrowKey: true,
		top: false,
		bottom: false,
		left: false,
		right: false,
		fixed: false,
		data: undefined,
		closeButton: true,
		fastIframe: true,
		open: false,
		reposition: true,
		loop: true,
		slideshow: false,
		slideshowAuto: true,
		slideshowSpeed: 2500,
		slideshowStart: "start slideshow",
		slideshowStop: "stop slideshow",
		photoRegex: /\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,

		// alternate image paths for high-res displays
		retinaImage: false,
		retinaUrl: false,
		retinaSuffix: '@2x.$1',

		// internationalization
		current: "image {current} of {total}",
		previous: "previous",
		next: "next",
		close: "close",
		xhrError: "This content failed to load.",
		imgError: "This image failed to load.",

		// accessbility
		returnFocus: true,
		trapFocus: true,

		// callbacks
		onOpen: false,
		onLoad: false,
		onComplete: false,
		onCleanup: false,
		onClosed: false,

		rel: function() {
			return this.rel;
		},
		href: function() {
			// using this.href would give the absolute url, when the href may have been inteded as a selector (e.g. '#container')
			return $(this).attr('href');
		},
		title: function() {
			return this.title;
		},
		createImg: function() {
			var img = new Image();
			var attrs = $(this).data('cbox-img-attrs');

			if (typeof attrs === 'object') {
				$.each(attrs, function(key, val){
					img[key] = val;
				});
			}

			return img;
		},
		createIframe: function() {
			var iframe = document.createElement('iframe');
			var attrs = $(this).data('cbox-iframe-attrs');

			if (typeof attrs === 'object') {
				$.each(attrs, function(key, val){
					iframe[key] = val;
				});
			}

			if ('frameBorder' in iframe) {
				iframe.frameBorder = 0;
			}
			if ('allowTransparency' in iframe) {
				iframe.allowTransparency = "true";
			}
			iframe.name = (new Date()).getTime(); // give the iframe a unique name to prevent caching
			iframe.allowFullscreen = true;

			return iframe;
		}
	},

	// Abstracting the HTML and event identifiers for easy rebranding
	colorbox = 'colorbox',
	prefix = 'cbox',
	boxElement = prefix + 'Element',

	// Events
	event_open = prefix + '_open',
	event_load = prefix + '_load',
	event_complete = prefix + '_complete',
	event_cleanup = prefix + '_cleanup',
	event_closed = prefix + '_closed',
	event_purge = prefix + '_purge',

	// Cached jQuery Object Variables
	$overlay,
	$box,
	$wrap,
	$content,
	$topBorder,
	$leftBorder,
	$rightBorder,
	$bottomBorder,
	$related,
	$window,
	$loaded,
	$loadingBay,
	$loadingOverlay,
	$title,
	$current,
	$slideshow,
	$next,
	$prev,
	$close,
	$groupControls,
	$events = $('<a/>'), // $({}) would be prefered, but there is an issue with jQuery 1.4.2

	// Variables for cached values or use across multiple functions
	settings,
	interfaceHeight,
	interfaceWidth,
	loadedHeight,
	loadedWidth,
	index,
	photo,
	open,
	active,
	closing,
	loadingTimer,
	publicMethod,
	div = "div",
	requests = 0,
	previousCSS = {},
	init;

	// ****************
	// HELPER FUNCTIONS
	// ****************

	// Convenience function for creating new jQuery objects
	function $tag(tag, id, css) {
		var element = document.createElement(tag);

		if (id) {
			element.id = prefix + id;
		}

		if (css) {
			element.style.cssText = css;
		}

		return $(element);
	}

	// Get the window height using innerHeight when available to avoid an issue with iOS
	// http://bugs.jquery.com/ticket/6724
	function winheight() {
		return window.innerHeight ? window.innerHeight : $(window).height();
	}

	function Settings(element, options) {
		if (options !== Object(options)) {
			options = {};
		}

		this.cache = {};
		this.el = element;

		this.value = function(key) {
			var dataAttr;

			if (this.cache[key] === undefined) {
				dataAttr = $(this.el).attr('data-cbox-'+key);

				if (dataAttr !== undefined) {
					this.cache[key] = dataAttr;
				} else if (options[key] !== undefined) {
					this.cache[key] = options[key];
				} else if (defaults[key] !== undefined) {
					this.cache[key] = defaults[key];
				}
			}

			return this.cache[key];
		};

		this.get = function(key) {
			var value = this.value(key);
			return $.isFunction(value) ? value.call(this.el, this) : value;
		};
	}

	// Determine the next and previous members in a group.
	function getIndex(increment) {
		var
		max = $related.length,
		newIndex = (index + increment) % max;

		return (newIndex < 0) ? max + newIndex : newIndex;
	}

	// Convert '%' and 'px' values to integers
	function setSize(size, dimension) {
		return Math.round((/%/.test(size) ? ((dimension === 'x' ? $window.width() : winheight()) / 100) : 1) * parseInt(size, 10));
	}

	// Checks an href to see if it is a photo.
	// There is a force photo option (photo: true) for hrefs that cannot be matched by the regex.
	function isImage(settings, url) {
		return settings.get('photo') || settings.get('photoRegex').test(url);
	}

	function retinaUrl(settings, url) {
		return settings.get('retinaUrl') && window.devicePixelRatio > 1 ? url.replace(settings.get('photoRegex'), settings.get('retinaSuffix')) : url;
	}

	function trapFocus(e) {
		if ('contains' in $box[0] && !$box[0].contains(e.target) && e.target !== $overlay[0]) {
			e.stopPropagation();
			$box.focus();
		}
	}

	function setClass(str) {
		if (setClass.str !== str) {
			$box.add($overlay).removeClass(setClass.str).addClass(str);
			setClass.str = str;
		}
	}

	function getRelated(rel) {
		index = 0;

		if (rel && rel !== false && rel !== 'nofollow') {
			$related = $('.' + boxElement).filter(function () {
				var options = $.data(this, colorbox);
				var settings = new Settings(this, options);
				return (settings.get('rel') === rel);
			});
			index = $related.index(settings.el);

			// Check direct calls to Colorbox.
			if (index === -1) {
				$related = $related.add(settings.el);
				index = $related.length - 1;
			}
		} else {
			$related = $(settings.el);
		}
	}

	function trigger(event) {
		// for external use
		$(document).trigger(event);
		// for internal use
		$events.triggerHandler(event);
	}

	var slideshow = (function(){
		var active,
			className = prefix + "Slideshow_",
			click = "click." + prefix,
			timeOut;

		function clear () {
			clearTimeout(timeOut);
		}

		function set() {
			if (settings.get('loop') || $related[index + 1]) {
				clear();
				timeOut = setTimeout(publicMethod.next, settings.get('slideshowSpeed'));
			}
		}

		function start() {
			$slideshow
				.html(settings.get('slideshowStop'))
				.unbind(click)
				.one(click, stop);

			$events
				.bind(event_complete, set)
				.bind(event_load, clear);

			$box.removeClass(className + "off").addClass(className + "on");
		}

		function stop() {
			clear();

			$events
				.unbind(event_complete, set)
				.unbind(event_load, clear);

			$slideshow
				.html(settings.get('slideshowStart'))
				.unbind(click)
				.one(click, function () {
					publicMethod.next();
					start();
				});

			$box.removeClass(className + "on").addClass(className + "off");
		}

		function reset() {
			active = false;
			$slideshow.hide();
			clear();
			$events
				.unbind(event_complete, set)
				.unbind(event_load, clear);
			$box.removeClass(className + "off " + className + "on");
		}

		return function(){
			if (active) {
				if (!settings.get('slideshow')) {
					$events.unbind(event_cleanup, reset);
					reset();
				}
			} else {
				if (settings.get('slideshow') && $related[1]) {
					active = true;
					$events.one(event_cleanup, reset);
					if (settings.get('slideshowAuto')) {
						start();
					} else {
						stop();
					}
					$slideshow.show();
				}
			}
		};

	}());


	function launch(element) {
		var options;

		if (!closing) {

			options = $(element).data(colorbox);

			settings = new Settings(element, options);

			getRelated(settings.get('rel'));

			if (!open) {
				open = active = true; // Prevents the page-change action from queuing up if the visitor holds down the left or right keys.

				setClass(settings.get('className'));

				// Show colorbox so the sizes can be calculated in older versions of jQuery
				$box.css({visibility:'hidden', display:'block', opacity:''});

				$loaded = $tag(div, 'LoadedContent', 'width:0; height:0; overflow:hidden; visibility:hidden');
				$content.css({width:'', height:''}).append($loaded);

				// Cache values needed for size calculations
				interfaceHeight = $topBorder.height() + $bottomBorder.height() + $content.outerHeight(true) - $content.height();
				interfaceWidth = $leftBorder.width() + $rightBorder.width() + $content.outerWidth(true) - $content.width();
				loadedHeight = $loaded.outerHeight(true);
				loadedWidth = $loaded.outerWidth(true);

				// Opens inital empty Colorbox prior to content being loaded.
				var initialWidth = setSize(settings.get('initialWidth'), 'x');
				var initialHeight = setSize(settings.get('initialHeight'), 'y');
				var maxWidth = settings.get('maxWidth');
				var maxHeight = settings.get('maxHeight');

				settings.w = Math.max((maxWidth !== false ? Math.min(initialWidth, setSize(maxWidth, 'x')) : initialWidth) - loadedWidth - interfaceWidth, 0);
				settings.h = Math.max((maxHeight !== false ? Math.min(initialHeight, setSize(maxHeight, 'y')) : initialHeight) - loadedHeight - interfaceHeight, 0);

				$loaded.css({width:'', height:settings.h});
				publicMethod.position();

				trigger(event_open);
				settings.get('onOpen');

				$groupControls.add($title).hide();

				$box.focus();

				if (settings.get('trapFocus')) {
					// Confine focus to the modal
					// Uses event capturing that is not supported in IE8-
					if (document.addEventListener) {

						document.addEventListener('focus', trapFocus, true);

						$events.one(event_closed, function () {
							document.removeEventListener('focus', trapFocus, true);
						});
					}
				}

				// Return focus on closing
				if (settings.get('returnFocus')) {
					$events.one(event_closed, function () {
						$(settings.el).focus();
					});
				}
			}

			var opacity = parseFloat(settings.get('opacity'));
			$overlay.css({
				opacity: opacity === opacity ? opacity : '',
				cursor: settings.get('overlayClose') ? 'pointer' : '',
				visibility: 'visible'
			}).show();

			if (settings.get('closeButton')) {
				$close.html(settings.get('close')).appendTo($content);
			} else {
				$close.appendTo('<div/>'); // replace with .detach() when dropping jQuery < 1.4
			}

			load();
		}
	}

	// Colorbox's markup needs to be added to the DOM prior to being called
	// so that the browser will go ahead and load the CSS background images.
	function appendHTML() {
		if (!$box) {
			init = false;
			$window = $(window);
			$box = $tag(div).attr({
				id: colorbox,
				'class': $.support.opacity === false ? prefix + 'IE' : '', // class for optional IE8 & lower targeted CSS.
				role: 'dialog',
				tabindex: '-1'
			}).hide();
			$overlay = $tag(div, "Overlay").hide();
			$loadingOverlay = $([$tag(div, "LoadingOverlay")[0],$tag(div, "LoadingGraphic")[0]]);
			$wrap = $tag(div, "Wrapper");
			$content = $tag(div, "Content").append(
				$title = $tag(div, "Title"),
				$current = $tag(div, "Current"),
				$prev = $('<button type="button"/>').attr({id:prefix+'Previous'}),
				$next = $('<button type="button"/>').attr({id:prefix+'Next'}),
				$slideshow = $('<button type="button"/>').attr({id:prefix+'Slideshow'}),
				$loadingOverlay
			);

			$close = $('<button type="button"/>').attr({id:prefix+'Close'});

			$wrap.append( // The 3x3 Grid that makes up Colorbox
				$tag(div).append(
					$tag(div, "TopLeft"),
					$topBorder = $tag(div, "TopCenter"),
					$tag(div, "TopRight")
				),
				$tag(div, false, 'clear:left').append(
					$leftBorder = $tag(div, "MiddleLeft"),
					$content,
					$rightBorder = $tag(div, "MiddleRight")
				),
				$tag(div, false, 'clear:left').append(
					$tag(div, "BottomLeft"),
					$bottomBorder = $tag(div, "BottomCenter"),
					$tag(div, "BottomRight")
				)
			).find('div div').css({'float': 'left'});

			$loadingBay = $tag(div, false, 'position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;');

			$groupControls = $next.add($prev).add($current).add($slideshow);
		}
		if (document.body && !$box.parent().length) {
			$(document.body).append($overlay, $box.append($wrap, $loadingBay));
		}
	}

	// Add Colorbox's event bindings
	function addBindings() {
		function clickHandler(e) {
			// ignore non-left-mouse-clicks and clicks modified with ctrl / command, shift, or alt.
			// See: http://jacklmoore.com/notes/click-events/
			if (!(e.which > 1 || e.shiftKey || e.altKey || e.metaKey || e.ctrlKey)) {
				e.preventDefault();
				launch(this);
			}
		}

		if ($box) {
			if (!init) {
				init = true;

				// Anonymous functions here keep the public method from being cached, thereby allowing them to be redefined on the fly.
				$next.click(function () {
					publicMethod.next();
				});
				$prev.click(function () {
					publicMethod.prev();
				});
				$close.click(function () {
					publicMethod.close();
				});
				$overlay.click(function () {
					if (settings.get('overlayClose')) {
						publicMethod.close();
					}
				});

				// Key Bindings
				$(document).bind('keydown.' + prefix, function (e) {
					var key = e.keyCode;
					if (open && settings.get('escKey') && key === 27) {
						e.preventDefault();
						publicMethod.close();
					}
					if (open && settings.get('arrowKey') && $related[1] && !e.altKey) {
						if (key === 37) {
							e.preventDefault();
							$prev.click();
						} else if (key === 39) {
							e.preventDefault();
							$next.click();
						}
					}
				});

				if ($.isFunction($.fn.on)) {
					// For jQuery 1.7+
					$(document).on('click.'+prefix, '.'+boxElement, clickHandler);
				} else {
					// For jQuery 1.3.x -> 1.6.x
					// This code is never reached in jQuery 1.9, so do not contact me about 'live' being removed.
					// This is not here for jQuery 1.9, it's here for legacy users.
					$('.'+boxElement).live('click.'+prefix, clickHandler);
				}
			}
			return true;
		}
		return false;
	}

	// Don't do anything if Colorbox already exists.
	if ($[colorbox]) {
		return;
	}

	// Append the HTML when the DOM loads
	$(appendHTML);


	// ****************
	// PUBLIC FUNCTIONS
	// Usage format: $.colorbox.close();
	// Usage from within an iframe: parent.jQuery.colorbox.close();
	// ****************

	publicMethod = $.fn[colorbox] = $[colorbox] = function (options, callback) {
		var settings;
		var $obj = this;

		options = options || {};

		if ($.isFunction($obj)) { // assume a call to $.colorbox
			$obj = $('<a/>');
			options.open = true;
		}

		if (!$obj[0]) { // colorbox being applied to empty collection
			return $obj;
		}

		appendHTML();

		if (addBindings()) {

			if (callback) {
				options.onComplete = callback;
			}

			$obj.each(function () {
				var old = $.data(this, colorbox) || {};
				$.data(this, colorbox, $.extend(old, options));
			}).addClass(boxElement);

			settings = new Settings($obj[0], options);

			if (settings.get('open')) {
				launch($obj[0]);
			}
		}

		return $obj;
	};

	publicMethod.position = function (speed, loadedCallback) {
		var
		css,
		top = 0,
		left = 0,
		offset = $box.offset(),
		scrollTop,
		scrollLeft;

		$window.unbind('resize.' + prefix);

		// remove the modal so that it doesn't influence the document width/height
		$box.css({top: -9e4, left: -9e4});

		scrollTop = $window.scrollTop();
		scrollLeft = $window.scrollLeft();

		if (settings.get('fixed')) {
			offset.top -= scrollTop;
			offset.left -= scrollLeft;
			$box.css({position: 'fixed'});
		} else {
			top = scrollTop;
			left = scrollLeft;
			$box.css({position: 'absolute'});
		}

		// keeps the top and left positions within the browser's viewport.
		if (settings.get('right') !== false) {
			left += Math.max($window.width() - settings.w - loadedWidth - interfaceWidth - setSize(settings.get('right'), 'x'), 0);
		} else if (settings.get('left') !== false) {
			left += setSize(settings.get('left'), 'x');
		} else {
			left += Math.round(Math.max($window.width() - settings.w - loadedWidth - interfaceWidth, 0) / 2);
		}

		if (settings.get('bottom') !== false) {
			top += Math.max(winheight() - settings.h - loadedHeight - interfaceHeight - setSize(settings.get('bottom'), 'y'), 0);
		} else if (settings.get('top') !== false) {
			top += setSize(settings.get('top'), 'y');
		} else {
			top += Math.round(Math.max(winheight() - settings.h - loadedHeight - interfaceHeight, 0) / 2);
		}

		$box.css({top: offset.top, left: offset.left, visibility:'visible'});

		// this gives the wrapper plenty of breathing room so it's floated contents can move around smoothly,
		// but it has to be shrank down around the size of div#colorbox when it's done.  If not,
		// it can invoke an obscure IE bug when using iframes.
		$wrap[0].style.width = $wrap[0].style.height = "9999px";

		function modalDimensions() {
			$topBorder[0].style.width = $bottomBorder[0].style.width = $content[0].style.width = (parseInt($box[0].style.width,10) - interfaceWidth)+'px';
			$content[0].style.height = $leftBorder[0].style.height = $rightBorder[0].style.height = (parseInt($box[0].style.height,10) - interfaceHeight)+'px';
		}

		css = {width: settings.w + loadedWidth + interfaceWidth, height: settings.h + loadedHeight + interfaceHeight, top: top, left: left};

		// setting the speed to 0 if the content hasn't changed size or position
		if (speed) {
			var tempSpeed = 0;
			$.each(css, function(i){
				if (css[i] !== previousCSS[i]) {
					tempSpeed = speed;
					return;
				}
			});
			speed = tempSpeed;
		}

		previousCSS = css;

		if (!speed) {
			$box.css(css);
		}

		$box.dequeue().animate(css, {
			duration: speed || 0,
			complete: function () {
				modalDimensions();

				active = false;

				// shrink the wrapper down to exactly the size of colorbox to avoid a bug in IE's iframe implementation.
				$wrap[0].style.width = (settings.w + loadedWidth + interfaceWidth) + "px";
				$wrap[0].style.height = (settings.h + loadedHeight + interfaceHeight) + "px";

				if (settings.get('reposition')) {
					setTimeout(function () {  // small delay before binding onresize due to an IE8 bug.
						$window.bind('resize.' + prefix, publicMethod.position);
					}, 1);
				}

				if ($.isFunction(loadedCallback)) {
					loadedCallback();
				}
			},
			step: modalDimensions
		});
	};

	publicMethod.resize = function (options) {
		var scrolltop;

		if (open) {
			options = options || {};

			if (options.width) {
				settings.w = setSize(options.width, 'x') - loadedWidth - interfaceWidth;
			}

			if (options.innerWidth) {
				settings.w = setSize(options.innerWidth, 'x');
			}

			$loaded.css({width: settings.w});

			if (options.height) {
				settings.h = setSize(options.height, 'y') - loadedHeight - interfaceHeight;
			}

			if (options.innerHeight) {
				settings.h = setSize(options.innerHeight, 'y');
			}

			if (!options.innerHeight && !options.height) {
				scrolltop = $loaded.scrollTop();
				$loaded.css({height: "auto"});
				settings.h = $loaded.height();
			}

			$loaded.css({height: settings.h});

			if(scrolltop) {
				$loaded.scrollTop(scrolltop);
			}

			publicMethod.position(settings.get('transition') === "none" ? 0 : settings.get('speed'));
		}
	};

	publicMethod.prep = function (object) {
		if (!open) {
			return;
		}

		var callback, speed = settings.get('transition') === "none" ? 0 : settings.get('speed');

		$loaded.remove();

		$loaded = $tag(div, 'LoadedContent').append(object);

		function getWidth() {
			settings.w = settings.w || $loaded.width();
			settings.w = settings.mw && settings.mw < settings.w ? settings.mw : settings.w;
			return settings.w;
		}
		function getHeight() {
			settings.h = settings.h || $loaded.height();
			settings.h = settings.mh && settings.mh < settings.h ? settings.mh : settings.h;
			return settings.h;
		}

		$loaded.hide()
		.appendTo($loadingBay.show())// content has to be appended to the DOM for accurate size calculations.
		.css({width: getWidth(), overflow: settings.get('scrolling') ? 'auto' : 'hidden'})
		.css({height: getHeight()})// sets the height independently from the width in case the new width influences the value of height.
		.prependTo($content);

		$loadingBay.hide();

		// floating the IMG removes the bottom line-height and fixed a problem where IE miscalculates the width of the parent element as 100% of the document width.

		$(photo).css({'float': 'none'});

		setClass(settings.get('className'));

		callback = function () {
			var total = $related.length,
				iframe,
				complete;

			if (!open) {
				return;
			}

			function removeFilter() { // Needed for IE8 in versions of jQuery prior to 1.7.2
				if ($.support.opacity === false) {
					$box[0].style.removeAttribute('filter');
				}
			}

			complete = function () {
				clearTimeout(loadingTimer);
				$loadingOverlay.hide();
				trigger(event_complete);
				settings.get('onComplete');
			};


			$title.html(settings.get('title')).show();
			$loaded.show();

			if (total > 1) { // handle grouping
				if (typeof settings.get('current') === "string") {
					$current.html(settings.get('current').replace('{current}', index + 1).replace('{total}', total)).show();
				}

				$next[(settings.get('loop') || index < total - 1) ? "show" : "hide"]().html(settings.get('next'));
				$prev[(settings.get('loop') || index) ? "show" : "hide"]().html(settings.get('previous'));

				slideshow();

				// Preloads images within a rel group
				if (settings.get('preloading')) {
					$.each([getIndex(-1), getIndex(1)], function(){
						var img,
							i = $related[this],
							settings = new Settings(i, $.data(i, colorbox)),
							src = settings.get('href');

						if (src && isImage(settings, src)) {
							src = retinaUrl(settings, src);
							img = document.createElement('img');
							img.src = src;
						}
					});
				}
			} else {
				$groupControls.hide();
			}

			if (settings.get('iframe')) {

				iframe = settings.get('createIframe');

				if (!settings.get('scrolling')) {
					iframe.scrolling = "no";
				}

				$(iframe)
					.attr({
						src: settings.get('href'),
						'class': prefix + 'Iframe'
					})
					.one('load', complete)
					.appendTo($loaded);

				$events.one(event_purge, function () {
					iframe.src = "//about:blank";
				});

				if (settings.get('fastIframe')) {
					$(iframe).trigger('load');
				}
			} else {
				complete();
			}

			if (settings.get('transition') === 'fade') {
				$box.fadeTo(speed, 1, removeFilter);
			} else {
				removeFilter();
			}
		};

		if (settings.get('transition') === 'fade') {
			$box.fadeTo(speed, 0, function () {
				publicMethod.position(0, callback);
			});
		} else {
			publicMethod.position(speed, callback);
		}
	};

	function load () {
		var href, setResize, prep = publicMethod.prep, $inline, request = ++requests;

		active = true;

		photo = false;

		trigger(event_purge);
		trigger(event_load);
		settings.get('onLoad');

		settings.h = settings.get('height') ?
				setSize(settings.get('height'), 'y') - loadedHeight - interfaceHeight :
				settings.get('innerHeight') && setSize(settings.get('innerHeight'), 'y');

		settings.w = settings.get('width') ?
				setSize(settings.get('width'), 'x') - loadedWidth - interfaceWidth :
				settings.get('innerWidth') && setSize(settings.get('innerWidth'), 'x');

		// Sets the minimum dimensions for use in image scaling
		settings.mw = settings.w;
		settings.mh = settings.h;

		// Re-evaluate the minimum width and height based on maxWidth and maxHeight values.
		// If the width or height exceed the maxWidth or maxHeight, use the maximum values instead.
		if (settings.get('maxWidth')) {
			settings.mw = setSize(settings.get('maxWidth'), 'x') - loadedWidth - interfaceWidth;
			settings.mw = settings.w && settings.w < settings.mw ? settings.w : settings.mw;
		}
		if (settings.get('maxHeight')) {
			settings.mh = setSize(settings.get('maxHeight'), 'y') - loadedHeight - interfaceHeight;
			settings.mh = settings.h && settings.h < settings.mh ? settings.h : settings.mh;
		}

		href = settings.get('href');

		loadingTimer = setTimeout(function () {
			$loadingOverlay.show();
		}, 100);

		if (settings.get('inline')) {
			var $target = $(href).eq(0);
			// Inserts an empty placeholder where inline content is being pulled from.
			// An event is bound to put inline content back when Colorbox closes or loads new content.
			$inline = $('<div>').hide().insertBefore($target);

			$events.one(event_purge, function () {
				$inline.replaceWith($target);
			});

			prep($target);
		} else if (settings.get('iframe')) {
			// IFrame element won't be added to the DOM until it is ready to be displayed,
			// to avoid problems with DOM-ready JS that might be trying to run in that iframe.
			prep(" ");
		} else if (settings.get('html')) {
			prep(settings.get('html'));
		} else if (isImage(settings, href)) {

			href = retinaUrl(settings, href);

			photo = settings.get('createImg');

			$(photo)
			.addClass(prefix + 'Photo')
			.bind('error.'+prefix,function () {
				prep($tag(div, 'Error').html(settings.get('imgError')));
			})
			.one('load', function () {
				if (request !== requests) {
					return;
				}

				// A small pause because some browsers will occassionaly report a
				// img.width and img.height of zero immediately after the img.onload fires
				setTimeout(function(){
					var percent;

					if (settings.get('retinaImage') && window.devicePixelRatio > 1) {
						photo.height = photo.height / window.devicePixelRatio;
						photo.width = photo.width / window.devicePixelRatio;
					}

					if (settings.get('scalePhotos')) {
						setResize = function () {
							photo.height -= photo.height * percent;
							photo.width -= photo.width * percent;
						};
						if (settings.mw && photo.width > settings.mw) {
							percent = (photo.width - settings.mw) / photo.width;
							setResize();
						}
						if (settings.mh && photo.height > settings.mh) {
							percent = (photo.height - settings.mh) / photo.height;
							setResize();
						}
					}

					if (settings.h) {
						photo.style.marginTop = Math.max(settings.mh - photo.height, 0) / 2 + 'px';
					}

					if ($related[1] && (settings.get('loop') || $related[index + 1])) {
						photo.style.cursor = 'pointer';

						$(photo).bind('click.'+prefix, function () {
							publicMethod.next();
						});
					}

					photo.style.width = photo.width + 'px';
					photo.style.height = photo.height + 'px';
					prep(photo);
				}, 1);
			});

			photo.src = href;

		} else if (href) {
			$loadingBay.load(href, settings.get('data'), function (data, status) {
				if (request === requests) {
					prep(status === 'error' ? $tag(div, 'Error').html(settings.get('xhrError')) : $(this).contents());
				}
			});
		}
	}

	// Navigates to the next page/image in a set.
	publicMethod.next = function () {
		if (!active && $related[1] && (settings.get('loop') || $related[index + 1])) {
			index = getIndex(1);
			launch($related[index]);
		}
	};

	publicMethod.prev = function () {
		if (!active && $related[1] && (settings.get('loop') || index)) {
			index = getIndex(-1);
			launch($related[index]);
		}
	};

	// Note: to use this within an iframe use the following format: parent.jQuery.colorbox.close();
	publicMethod.close = function () {
		if (open && !closing) {

			closing = true;
			open = false;
			trigger(event_cleanup);
			settings.get('onCleanup');
			$window.unbind('.' + prefix);
			$overlay.fadeTo(settings.get('fadeOut') || 0, 0);

			$box.stop().fadeTo(settings.get('fadeOut') || 0, 0, function () {
				$box.hide();
				$overlay.hide();
				trigger(event_purge);
				$loaded.remove();

				setTimeout(function () {
					closing = false;
					trigger(event_closed);
					settings.get('onClosed');
				}, 1);
			});
		}
	};

	// Removes changes Colorbox made to the document, but does not remove the plugin.
	publicMethod.remove = function () {
		if (!$box) { return; }

		$box.stop();
		$[colorbox].close();
		$box.stop(false, true).remove();
		$overlay.remove();
		closing = false;
		$box = null;
		$('.' + boxElement)
			.removeData(colorbox)
			.removeClass(boxElement);

		$(document).unbind('click.'+prefix).unbind('keydown.'+prefix);
	};

	// A method for fetching the current element Colorbox is referencing.
	// returns a jQuery object.
	publicMethod.element = function () {
		return $(settings.el);
	};

	publicMethod.settings = defaults;

}(jQuery, document, window));


( function( window, factory ) {
	if ( typeof define == 'function' && define.amd ) {
		define( 'jquery-bridget/jquery-bridget',[ 'jquery' ], function( jQuery ) {
			return factory( window, jQuery );
		});
	} else if ( typeof module == 'object' && module.exports ) {
		module.exports = factory(
			window,
			require('jquery')
		);
	} else {
		window.jQueryBridget = factory(
			window,
			window.jQuery
		);
	}

}( window, function factory( window, jQuery ) {
'use strict';

var arraySlice = Array.prototype.slice;
var console = window.console;
var logError = typeof console == 'undefined' ? function() {} :
function( message ) {
	console.error( message );
};

function jQueryBridget( namespace, PluginClass, $ ) {
	$ = $ || jQuery || window.jQuery;
	if ( !$ ) {
		return;
	}

	if ( !PluginClass.prototype.option ) {
		PluginClass.prototype.option = function( opts )
		{
			if ( !$.isPlainObject( opts ) )		{ return; }

			this.options						= $.extend( true, this.options, opts );
		};
	}

	$.fn[ namespace ] = function( arg0 /*, arg1 */ )
	{
		if ( typeof arg0 == 'string' )
		{
			var args = arraySlice.call( arguments, 1 );
			return methodCall( this, arg0, args );
		}
		plainCall( this, arg0 );
		return this;
	};

	function methodCall( $elems, methodName, args )
	{
		var returnValue;
		var pluginMethodStr = '$().' + namespace + '("' + methodName + '")';

		$elems.each( function( i, elem ) {
			// get instance
			var instance = $.data( elem, namespace );
			if ( !instance ) {
				logError( namespace + ' not initialized. Cannot call methods, i.e. ' +
					pluginMethodStr );
				return;
			}

			var method = instance[ methodName ];
			if ( !method || methodName.charAt(0) == '_' ) {
				logError( pluginMethodStr + ' is not a valid method' );
				return;
			}

			var value							= method.apply( instance, args );
			returnValue							= returnValue === undefined ? value : returnValue;
		});

		return (returnValue !== undefined ? returnValue : $elems);
	}

	function plainCall( $elems, options ) {
		$elems.each( function( i, elem ) {
			var instance = $.data( elem, namespace );
			if ( instance ) {
				instance.option( options );
				instance._init();
			} else {
				instance = new PluginClass( elem, options );
				$.data( elem, namespace, instance );
			}
		});
	}

	updateJQuery( $ );

}

function updateJQuery( $ ) {
	if ( !$ || ( $ && $.bridget ) )				{ return; }
	$.bridget									= jQueryBridget;
}

updateJQuery( jQuery || window.jQuery );

return jQueryBridget;

}));

/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

( function( global, factory ) {
	// universal module definition
	/* jshint strict: false */ /* globals define, module, window */
	if ( typeof define == 'function' && define.amd ) {
		// AMD - RequireJS
		define( 'ev-emitter/ev-emitter',factory );
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS - Browserify, Webpack
		module.exports = factory();
	} else {
		// Browser globals
		global.EvEmitter = factory();
	}

}( typeof window != 'undefined' ? window : this, function() {



function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
	if ( !eventName || !listener ) {
		return;
	}
	// set events hash
	var events = this._events = this._events || {};
	// set listeners array
	var listeners = events[ eventName ] = events[ eventName ] || [];
	// only add once
	if ( listeners.indexOf( listener ) == -1 ) {
		listeners.push( listener );
	}

	return this;
};

proto.once = function( eventName, listener ) {
	if ( !eventName || !listener ) {
		return;
	}
	// add event
	this.on( eventName, listener );
	// set once flag
	// set onceEvents hash
	var onceEvents = this._onceEvents = this._onceEvents || {};
	// set onceListeners object
	var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	// set flag
	onceListeners[ listener ] = true;

	return this;
};

proto.off = function( eventName, listener ) {
	var listeners = this._events && this._events[ eventName ];
	if ( !listeners || !listeners.length ) {
		return;
	}
	var index = listeners.indexOf( listener );
	if ( index != -1 ) {
		listeners.splice( index, 1 );
	}

	return this;
};

proto.emitEvent = function( eventName, args ) {
	var listeners = this._events && this._events[ eventName ];
	if ( !listeners || !listeners.length ) {
		return;
	}
	// copy over to avoid interference if .off() in listener
	listeners = listeners.slice(0);
	args = args || [];
	// once stuff
	var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

	for ( var i=0; i < listeners.length; i++ ) {
		var listener = listeners[i]
		var isOnce = onceListeners && onceListeners[ listener ];
		if ( isOnce ) {
			// remove listener
			// remove before trigger to prevent recursion
			this.off( eventName, listener );
			// unset once flag
			delete onceListeners[ listener ];
		}
		// trigger listener
		listener.apply( this, args );
	}

	return this;
};

proto.allOff = function() {
	delete this._events;
	delete this._onceEvents;
};

return EvEmitter;

}));

/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

( function( window, factory ) {
	/*global define: false, module: false */
	'use strict';
	// universal module definition
	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define( 'desandro-matches-selector/matches-selector',factory );
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory();
	} else {
		// browser global
		window.matchesSelector = factory();
	}

}( window, function factory() {
	'use strict';

	var matchesMethod = ( function() {
		var ElemProto = window.Element.prototype;
		// check for the standard method name first
		if ( ElemProto.matches ) {
			return 'matches';
		}
		// check un-prefixed
		if ( ElemProto.matchesSelector ) {
			return 'matchesSelector';
		}
		// check vendor prefixes
		var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

		for ( var i=0; i < prefixes.length; i++ ) {
			var prefix = prefixes[i];
			var method = prefix + 'MatchesSelector';
			if ( ElemProto[ method ] ) {
				return method;
			}
		}
	})();

	return function matchesSelector( elem, selector ) {
		return elem[ matchesMethod ]( selector );
	};

}));

/**
 * Fizzy UI utils v2.0.5
 * MIT license
 */

( function( window, factory ) {
	// universal module definition
	/*jshint strict: false */ /*globals define, module, require */

	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define( 'fizzy-ui-utils/utils',[
			'desandro-matches-selector/matches-selector'
		], function( matchesSelector ) {
			return factory( window, matchesSelector );
		});
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory(
			window,
			require('desandro-matches-selector')
		);
	} else {
		// browser global
		window.fizzyUIUtils = factory(
			window,
			window.matchesSelector
		);
	}

}( window, function factory( window, matchesSelector ) {



var utils = {};

// extends objects
utils.extend = function( a, b ) {
	for ( var prop in b ) {
		a[ prop ] = b[ prop ];
	}
	return a;
};

utils.modulo = function( num, div ) {
	return ( ( num % div ) + div ) % div;
};

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
	var ary = [];
	if ( Array.isArray( obj ) ) {
		// use object if already an array
		ary = obj;
	} else if ( obj && typeof obj == 'object' &&
		typeof obj.length == 'number' ) {
		// convert nodeList to array
		for ( var i=0; i < obj.length; i++ ) {
			ary.push( obj[i] );
		}
	} else {
		// array of single index
		ary.push( obj );
	}
	return ary;
};

utils.removeFrom = function( ary, obj ) {
	var index = ary.indexOf( obj );
	if ( index != -1 ) {
		ary.splice( index, 1 );
	}
};

utils.getParent = function( elem, selector ) {
	while ( elem.parentNode && elem != document.body ) {
		elem = elem.parentNode;
		if ( matchesSelector( elem, selector ) ) {
			return elem;
		}
	}
};

// use element as selector string
utils.getQueryElement = function( elem ) {
	if ( typeof elem == 'string' ) {
		return document.querySelector( elem );
	}
	return elem;
};

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
	var method = 'on' + event.type;
	if ( this[ method ] ) {
		this[ method ]( event );
	}
};

utils.filterFindElements = function( elems, selector ) {
	// make array of elems
	elems = utils.makeArray( elems );
	var ffElems = [];

	elems.forEach( function( elem ) {
		// check that elem is an actual element
		if ( !( elem instanceof HTMLElement ) ) {
			return;
		}
		// add elem if no selector
		if ( !selector ) {
			ffElems.push( elem );
			return;
		}
		// filter & find items if we have a selector
		// filter
		if ( matchesSelector( elem, selector ) ) {
			ffElems.push( elem );
		}
		// find children
		var childElems = elem.querySelectorAll( selector );
		// concat childElems to filterFound array
		for ( var i=0; i < childElems.length; i++ ) {
			ffElems.push( childElems[i] );
		}
	});

	return ffElems;
};

utils.debounceMethod = function( _class, methodName, threshold ) {
	// original method
	var method = _class.prototype[ methodName ];
	var timeoutName = methodName + 'Timeout';

	_class.prototype[ methodName ] = function() {
		var timeout = this[ timeoutName ];
		if ( timeout ) {
			clearTimeout( timeout );
		}
		var args = arguments;

		var _this = this;
		this[ timeoutName ] = setTimeout( function() {
			method.apply( _this, args );
			delete _this[ timeoutName ];
		}, threshold || 100 );
	};
};

utils.docReady = function( callback ) {
	var readyState = document.readyState;
	if ( readyState == 'complete' || readyState == 'interactive' ) {
		// do async to allow for other scripts to run. metafizzy/flickity#441
		setTimeout( callback );
	} else {
		document.addEventListener( 'DOMContentLoaded', callback );
	}
};


utils.toDashed = function( str ) {
	return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
		return $1 + '-' + $2;
	}).toLowerCase();
};

var console = window.console;

utils.htmlInit = function( WidgetClass, namespace ) {
	utils.docReady( function() {
		var dashedNamespace = utils.toDashed( namespace );
		var dataAttr = 'data-' + dashedNamespace;
		var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
		var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
		var elems = utils.makeArray( dataAttrElems )
			.concat( utils.makeArray( jsDashElems ) );
		var dataOptionsAttr = dataAttr + '-options';
		var jQuery = window.jQuery;

		elems.forEach( function( elem ) {
			var attr = elem.getAttribute( dataAttr ) ||
				elem.getAttribute( dataOptionsAttr );
			var options;
			try {
				options = attr && JSON.parse( attr );
			} catch ( error ) {
				// log error, do not initialize
				if ( console ) {
					console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
					': ' + error );
				}
				return;
			}
			// initialize
			var instance = new WidgetClass( elem, options );
			// make available via $().data('namespace')
			if ( jQuery ) {
				jQuery.data( elem, namespace, instance );
			}
		});

	});
};

return utils;

}));

( function( window, factory ) {
	// universal module definition
	/* globals define, module, require */
	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define( 'infinite-scroll/js/core',[
			'ev-emitter/ev-emitter',
			'fizzy-ui-utils/utils',
		], function( EvEmitter, utils) {
			return factory( window, EvEmitter, utils );
		});
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory(
			window,
			require('ev-emitter'),
			require('fizzy-ui-utils')
		);
	} else {
		// browser global
		window.InfiniteScroll = factory(
			window,
			window.EvEmitter,
			window.fizzyUIUtils
		);
	}

}( window, function factory( window, EvEmitter, utils ) {

var jQuery = window.jQuery;
// internal store of all InfiniteScroll intances
var instances = {};

function InfiniteScroll( element, options ) {
	var queryElem = utils.getQueryElement( element );

	if ( !queryElem ) {
		console.error( 'Bad element for InfiniteScroll: ' + ( queryElem || element ) );
		return;
	}
	element = queryElem;
	// do not initialize twice on same element
	if ( element.infiniteScrollGUID ) {
		var instance = instances[ element.infiniteScrollGUID ];
		instance.option( options );
		return instance;
	}

	this.element = element;
	// options
	this.options = utils.extend( {}, InfiniteScroll.defaults );
	this.option( options );
	// add jQuery
	if ( jQuery ) {
		this.$element = jQuery( this.element );
	}

	this.create();
}

// defaults
InfiniteScroll.defaults = {
	// path: null,
	// hideNav: null,
	// debug: false,
};

// create & destroy methods
InfiniteScroll.create = {};
InfiniteScroll.destroy = {};

var proto = InfiniteScroll.prototype;
// inherit EvEmitter
utils.extend( proto, EvEmitter.prototype );

// --------------------------  -------------------------- //

// globally unique identifiers
var GUID = 0;

proto.create = function() {
	var id = this.guid = ++GUID;
	this.element.infiniteScrollGUID = id; // expando
	instances[ id ] = this; // associate via id
	// properties
	this.pageIndex = 1; // default to first page
	this.loadCount = 0;
	this.updateGetPath();
	// bail if getPath not set
	if ( !this.getPath ) {
		console.error('Disabling InfiniteScroll');
		return;
	}
	this.updateGetAbsolutePath();
	this.log( 'initialized', [ this.element.className ] );
	this.callOnInit();
	// create features
	for ( var method in InfiniteScroll.create ) {
		InfiniteScroll.create[ method ].call( this );
	}
};

proto.option = function( opts ) {
	utils.extend( this.options, opts );
};

// call onInit option, used for binding events on init
proto.callOnInit = function() {
	var onInit = this.options.onInit;
	if ( onInit ) {
		onInit.call( this, this );
	}
};

proto.dispatchEvent = function( type, event, args ) {
	this.log( type, args );
	var emitArgs = event ? [ event ].concat( args ) : args;
	this.emitEvent( type, emitArgs );
	// trigger jQuery event
	if ( !jQuery || !this.$element ) {
		return;
	}
	// namespace jQuery event
	type += '.infiniteScroll';
	var $event = type;
	if ( event ) {
		// create jQuery event
		var jQEvent = jQuery.Event( event );
		jQEvent.type = type;
		$event = jQEvent;
	}
	this.$element.trigger( $event, args );
};

var loggers = {
	initialized: function( className ) {
		return 'on ' + className;
	},
	request: function( path ) {
		return 'URL: ' + path;
	},
	load: function( response, path ) {
		return ( response.title || '' ) + '. URL: ' + path;
	},
	error: function( error, path ) {
		return error + '. URL: ' + path;
	},
	append: function( response, path, items ) {
		return items.length + ' items. URL: ' + path;
	},
	last: function( response, path ) {
		return 'URL: ' + path;
	},
	history: function( title, path ) {
		return 'URL: ' + path;
	},
	pageIndex: function( index, origin ) {
		return 'current page determined to be: ' + index + ' from ' + origin;
	},
};

// log events
proto.log = function( type, args ) {
	if ( !this.options.debug ) {
		return;
	}
	var message = '[InfiniteScroll] ' + type;
	var logger = loggers[ type ];
	if ( logger ) {
		message += '. ' + logger.apply( this, args );
	}
	console.log( message );
};

// -------------------------- methods used amoung features -------------------------- //

proto.updateMeasurements = function() {
	this.windowHeight = window.innerHeight;
	var rect = this.element.getBoundingClientRect();
	this.top = rect.top + window.pageYOffset;
};

proto.updateScroller = function() {
	var elementScroll = this.options.elementScroll;
	if ( !elementScroll ) {
		// default, use window
		this.scroller = window;
		return;
	}
	// if true, set to element, otherwise use option
	this.scroller = elementScroll === true ? this.element :
		utils.getQueryElement( elementScroll );
	if ( !this.scroller ) {
		throw 'Unable to find elementScroll: ' + elementScroll;
	}
};

// -------------------------- page path -------------------------- //

proto.updateGetPath = function() {
	var optPath = this.options.path;
	if ( !optPath ) {
		console.error( 'InfiniteScroll path option required. Set as: ' + optPath );
		return;
	}
	// function
	var type = typeof optPath;
	if ( type == 'function' ) {
		this.getPath = optPath;
		return;
	}
	// template string: '/pages/{{#}}.html'
	var templateMatch = type == 'string' && optPath.match('{{#}}');
	if ( templateMatch ) {
		this.updateGetPathTemplate( optPath );
		return;
	}
	// selector: '.next-page-selector'
	this.updateGetPathSelector( optPath );
};

proto.updateGetPathTemplate = function( optPath ) {
	// set getPath with template string
	this.getPath = function() {
		var nextIndex = this.pageIndex + 1;
		return optPath.replace( '{{#}}', nextIndex );
	}.bind( this );
	// get pageIndex from location
	// convert path option into regex to look for pattern in location
	var regexString = optPath.replace( '{{#}}', '(\\d\\d?\\d?)' );
	var templateRe = new RegExp( regexString );
	var match = location.href.match( templateRe );
	if ( match ) {
		this.pageIndex = parseInt( match[1], 10 );
		this.log( 'pageIndex', this.pageIndex, 'template string' );
	}
};

var pathRegexes = [
	/^(.*?\/?page\/?)(\d\d?\d?)(.*?$)/,
	/^(.*?\/?\?page=)(\d\d?\d?)(.*?$)/,
	/(.*?)(\d\d?\d?)(?!.*\d)(.*?$)/,
];

proto.updateGetPathSelector = function( optPath ) {
	// parse href of link: '.next-page-link'
	var hrefElem = document.querySelector( optPath );
	if ( !hrefElem ) {
		console.error( 'Bad InfiniteScroll path option. Next link not found: ' +
			optPath );
		return;
	}
	var href = hrefElem.getAttribute('href');
	// try matching href to pathRegexes patterns
	var pathParts, regex;
	for ( var i=0; href && i < pathRegexes.length; i++ ) {
		regex = pathRegexes[i];
		var match = href.match( regex );
		if ( match ) {
			pathParts = match.slice(1); // remove first part
			break;
		}
	}
	if ( !pathParts ) {
		console.error( 'InfiniteScroll unable to parse next link href: ' + href );
		return;
	}
	this.isPathSelector = true; // flag for checkLastPage()
	this.getPath = function() {
		var nextIndex = this.pageIndex + 1;
		return pathParts[0] + nextIndex + pathParts[2];
	}.bind( this );
	// get pageIndex from href
	this.pageIndex = parseInt( pathParts[1], 10 ) - 1;
	this.log( 'pageIndex', [ this.pageIndex, 'next link' ] );
};

proto.updateGetAbsolutePath = function() {
	var path = this.getPath();
	// path doesn't start with http or /
	var isAbsolute = path.match( /^http/ ) || path.match( /^\// );
	if ( isAbsolute ) {
		this.getAbsolutePath = this.getPath;
		return;
	}

	var pathname = location.pathname;
	// /foo/bar/index.html => /foo/bar
	var directory = pathname.substring( 0, pathname.lastIndexOf('/') );

	this.getAbsolutePath = function() {
		return directory + '/' + this.getPath();
	};
};

// hide navigation
InfiniteScroll.create.hideNav = function() {
	var nav = utils.getQueryElement( this.options.hideNav );
	if ( !nav ) {
		return;
	}
	nav.style.display = 'none';
	this.nav = nav;
};

InfiniteScroll.destroy.hideNav = function() {
	if ( this.nav ) {
		this.nav.style.display = '';
	}
};

proto.destroy = function() {
	this.allOff(); // remove all event listeners
	// call destroy methods
	for ( var method in InfiniteScroll.destroy ) {
		InfiniteScroll.destroy[ method ].call( this );
	}

	delete this.element.infiniteScrollGUID;
	delete instances[ this.guid ];
};

InfiniteScroll.throttle = function( fn, threshold ) {
	threshold = threshold || 200;
	var last, timeout;

	return function() {
		var now = +new Date();
		var args = arguments;
		var trigger = function() {
			last = now;
			fn.apply( this, args );
		}.bind( this );
		if ( last && now < last + threshold ) {
			// hold on to it
			clearTimeout( timeout );
			timeout = setTimeout( trigger, threshold );
		} else {
			trigger();
		}
	};
};

InfiniteScroll.data = function( elem ) {
	elem = utils.getQueryElement( elem );
	var id = elem && elem.infiniteScrollGUID;
	return id && instances[ id ];
};

// set internal jQuery, for Webpack + jQuery v3
InfiniteScroll.setJQuery = function( $ ) {
	jQuery = $;
};

utils.htmlInit( InfiniteScroll, 'infinite-scroll' );

if ( jQuery && jQuery.bridget ) {
	jQuery.bridget( 'infiniteScroll', InfiniteScroll );
}

return InfiniteScroll;

}));

// page-load
( function( window, factory ) {
	// universal module definition
	/* globals define, module, require */
	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define( 'infinite-scroll/js/page-load',[
			'./core',
		], function( InfiniteScroll ) {
			return factory( window, InfiniteScroll );
		});
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory(
			window,
			require('./core')
		);
	} else {
		// browser global
		factory(
			window,
			window.InfiniteScroll
		);
	}

}( window, function factory( window, InfiniteScroll ) {

var proto = InfiniteScroll.prototype;

InfiniteScroll.defaults.loadOnScroll = true;
InfiniteScroll.defaults.checkLastPage = true;
InfiniteScroll.defaults.responseType = 'document';

InfiniteScroll.create.pageLoad = function() {
	this.canLoad = true;
	this.on( 'scrollThreshold', this.onScrollThresholdLoad );
	this.on( 'load', this.checkLastPage );
	if ( this.options.outlayer ) {
		this.on( 'append', this.onAppendOutlayer );
	}
};

proto.onScrollThresholdLoad = function() {
	if ( this.options.loadOnScroll ) {
		this.loadNextPage();
	}
};

proto.loadNextPage = function() {
	if ( this.isLoading || !this.canLoad ) {
		return;
	}

	var path = this.getAbsolutePath();
	this.isLoading = true;

	var onLoad = function( response ) {
		this.onPageLoad( response, path );
	}.bind( this );

	var onError = function( error ) {
		this.onPageError( error, path );
	}.bind( this );

	request( path, this.options.responseType, onLoad, onError, this.options.usepost );
	this.dispatchEvent( 'request', null, [ path ] );
};

proto.onPageLoad = function( response, path ) {
	// done loading if not appending
	if ( !this.options.append ) {
		this.isLoading = false;
	}
	this.pageIndex++;
	this.loadCount++;
	this.dispatchEvent( 'load', null, [ response, path ] );
	this.appendNextPage( response, path );
	return response;
};

proto.appendNextPage = function( response, path ) {
	var optAppend = this.options.append;
	// do not append json
	var isDocument = this.options.responseType == 'document';
	if ( !isDocument || !optAppend ) {
		return;
	}

	var items = response.querySelectorAll( optAppend );
	var fragment = getItemsFragment( items );
	var appendReady = function () {
		this.appendItems( items, fragment );
		this.isLoading = false;
		this.dispatchEvent( 'append', null, [ response, path, items ] );
	}.bind( this );

	// TODO add hook for option to trigger appendReady
	if ( this.options.outlayer ) {
		this.appendOutlayerItems( fragment, appendReady );
	} else {
		appendReady();
	}
};

proto.appendItems = function( items, fragment ) {
	if ( !items || !items.length ) {
		return;
	}
	// get fragment if not provided
	fragment = fragment || getItemsFragment( items );
	refreshScripts( fragment );
	this.element.appendChild( fragment );
};

function getItemsFragment( items ) {
	// add items to fragment
	var fragment = document.createDocumentFragment();
	for ( var i=0; items && i < items.length; i++ ) {
		fragment.appendChild( items[i] );
	}
	return fragment;
}

function refreshScripts( fragment ) {
	var scripts = fragment.querySelectorAll('script');
	for ( var i=0; i < scripts.length; i++ ) {
		var script = scripts[i];
		var freshScript = document.createElement('script');
		copyAttributes( script, freshScript );
		script.parentNode.replaceChild( freshScript, script );
	}
}

function copyAttributes( fromNode, toNode ) {
	var attrs = fromNode.attributes;
	for ( var i=0; i < attrs.length; i++ ) {
		var attr = attrs[i];
		toNode.setAttribute( attr.name, attr.value );
	}
}

proto.appendOutlayerItems = function( fragment, appendReady ) {
	var imagesLoaded = InfiniteScroll.imagesLoaded || window.imagesLoaded;
	if ( !imagesLoaded ) {
		console.error('[InfiniteScroll] imagesLoaded required for outlayer option');
		this.isLoading = false;
		return;
	}
	// append once images loaded
	imagesLoaded( fragment, appendReady );
};

proto.onAppendOutlayer = function( response, path, items ) {
	this.options.outlayer.appended( items );
};

// check response for next element
proto.checkLastPage = function( response, path ) {
	var checkLastPage = this.options.checkLastPage;
	if ( !checkLastPage ) {
		return;
	}

	var pathOpt = this.options.path;
	// if path is function, check if next path is truthy
	if ( typeof pathOpt == 'function' ) {
		var nextPath = this.getPath();
		if ( !nextPath ) {
			this.lastPageReached( response, path );
			return;
		}
	}
	// get selector from checkLastPage or path option
	var selector;
	if ( typeof checkLastPage == 'string' ) {
		selector = checkLastPage;
	} else if ( this.isPathSelector ) {
		// path option is selector string
		selector = pathOpt;
	}
	// check last page for selector
	// bail if no selector or not document response
	if ( !selector || !response.querySelector ) {
		return;
	}
	// check if response has selector
	var nextElem = response.querySelector( selector );
	if ( !nextElem ) {
		this.lastPageReached( response, path );
	}
};

proto.lastPageReached = function( response, path ) {
	this.canLoad = false;
	this.dispatchEvent( 'last', null, [ response, path ] );
};

// ----- error ----- //

proto.onPageError = function( error, path ) {
	this.isLoading = false;
	this.canLoad = false;
	this.dispatchEvent( 'error', null, [ error, path ] );
	return error;
};

// -------------------------- prefill -------------------------- //

InfiniteScroll.create.prefill = function() {
	if ( !this.options.prefill ) {
		return;
	}
	var append = this.options.append;
	if ( !append ) {
		console.error( 'append option required for prefill. Set as :' + append );
		return;
	}
	this.updateMeasurements();
	this.updateScroller();
	this.isPrefilling = true;
	this.on( 'append', this.prefill );
	this.once( 'error', this.stopPrefill );
	this.once( 'last', this.stopPrefill );
	this.prefill();
};

proto.prefill = function() {
	var distance = this.getPrefillDistance();
	this.isPrefilling = distance >= 0;
	if ( this.isPrefilling ) {
		this.log('prefill');
		this.loadNextPage();
	} else {
		this.stopPrefill();
	}
};

proto.getPrefillDistance = function() {
	// element scroll
	if ( this.options.elementScroll ) {
		return this.scroller.clientHeight - this.scroller.scrollHeight;
	}
	// window
	return this.windowHeight - this.element.clientHeight;
};

proto.stopPrefill = function() {
	console.log('stopping prefill');
	this.off( 'append', this.prefill );
};

// -------------------------- request -------------------------- //

function request( url, responseType, onLoad, onError, usepost ) {
	if (usepost)
	{
		/* Werkt NIET met jquery post / ajax!!! */
		var req = new XMLHttpRequest();
		req.open( 'POST', url, true );
		// set responseType document to return DOM
		req.responseType = responseType || '';

		// set X-Requested-With header to check that is ajax request
		req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

		req.onload = function() {
			if ( req.status == 200 ) {
				onLoad( req.response );
			} else {
				// not 200 OK, error
				var error = new Error( req.statusText );
				onError( error );
			}
		};

		// Handle network errors
		req.onerror = function() {
			var error = new Error( 'Network error requesting ' + url );
			onError( error );
		};

		req.send(getInfiniteScrollPostJSONParams());
	}
	else
	{
		var req = new XMLHttpRequest();
		req.open( 'GET', url, true );
		// set responseType document to return DOM
		req.responseType = responseType || '';
	
		// set X-Requested-With header to check that is ajax request
		req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	
		req.onload = function() {
			if ( req.status == 200 ) {
				onLoad( req.response );
			} else {
				// not 200 OK, error
				var error = new Error( req.statusText );
				onError( error );
			}
		};
	
		// Handle network errors
		req.onerror = function() {
			var error = new Error( 'Network error requesting ' + url );
			onError( error );
		};
	
		req.send();
	}
}

return InfiniteScroll;

}));

// scroll-watch
( function( window, factory ) {
	// universal module definition
	/* globals define, module, require */
	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define( 'infinite-scroll/js/scroll-watch',[
			'./core',
			'fizzy-ui-utils/utils',
		], function( InfiniteScroll, utils ) {
			return factory( window, InfiniteScroll, utils );
		});
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory(
			window,
			require('./core'),
			require('fizzy-ui-utils')
		);
	} else {
		// browser global
		factory(
			window,
			window.InfiniteScroll,
			window.fizzyUIUtils
		);
	}

}( window, function factory( window, InfiniteScroll, utils ) {

var proto = InfiniteScroll.prototype;

// default options
InfiniteScroll.defaults.scrollThreshold = 400;

InfiniteScroll.create.scrollWatch = function() {
	// events
	this.pageScrollHandler = this.onPageScroll.bind( this );
	this.resizeHandler = this.onResize.bind( this );

	var scrollThreshold = this.options.scrollThreshold;
	var isEnable = scrollThreshold || scrollThreshold === 0;
	if ( isEnable ) {
		this.enableScrollWatch();
	}
};

InfiniteScroll.destroy.scrollWatch = function() {
	this.disableScrollWatch();
};

proto.enableScrollWatch = function() {
	if ( this.isScrollWatching ) {
		return;
	}
	this.isScrollWatching = true;
	this.updateMeasurements();
	this.updateScroller();
	// TODO disable after error?
	this.on( 'last', this.disableScrollWatch );
	this.bindScrollWatchEvents( true );
};

proto.disableScrollWatch = function() {
	if ( !this.isScrollWatching ) {
		return;
	}
	this.bindScrollWatchEvents( false );
	delete this.isScrollWatching;
};

proto.bindScrollWatchEvents = function( isBind ) {
	var addRemove = isBind ? 'addEventListener' : 'removeEventListener';
	this.scroller[ addRemove ]( 'scroll', this.pageScrollHandler );
	window[ addRemove ]( 'resize', this.resizeHandler );
};

proto.onPageScroll = InfiniteScroll.throttle( function() {
	var distance = this.getBottomDistance();
	if ( distance <= this.options.scrollThreshold ) {
		this.dispatchEvent('scrollThreshold');
	}
});

proto.getBottomDistance = function() {
	if ( this.options.elementScroll ) {
		return this.getElementBottomDistance();
	} else {
		return this.getWindowBottomDistance();
	}
};

proto.getWindowBottomDistance = function() {
	var bottom = this.top + this.element.clientHeight;
	var scrollY = window.pageYOffset + this.windowHeight;
	return bottom - scrollY;
};

proto.getElementBottomDistance = function() {
	var bottom = this.scroller.scrollHeight;
	var scrollY = this.scroller.scrollTop + this.scroller.clientHeight;
	return bottom - scrollY;
};

proto.onResize = function() {
	this.updateMeasurements();
};

utils.debounceMethod( InfiniteScroll, 'onResize', 150 );


return InfiniteScroll;

}));

// history
( function( window, factory ) {
	// universal module definition
	/* globals define, module, require */
	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define( 'infinite-scroll/js/history',[
			'./core',
			'fizzy-ui-utils/utils',
		], function( InfiniteScroll, utils ) {
			return factory( window, InfiniteScroll, utils );
		});
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory(
			window,
			require('./core'),
			require('fizzy-ui-utils')
		);
	} else {
		// browser global
		factory(
			window,
			window.InfiniteScroll,
			window.fizzyUIUtils
		);
	}

}( window, function factory( window, InfiniteScroll, utils ) {

var proto = InfiniteScroll.prototype;

InfiniteScroll.defaults.history = 'replace';
// InfiniteScroll.defaults.historyTitle = false;

var link = document.createElement('a');

// ----- create/destroy ----- //

InfiniteScroll.create.history = function() {
	if ( !this.options.history ) {
		return;
	}
	// check for same origin
	link.href = this.getAbsolutePath();
	// MS Edge does not have origin on link https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12236493/
	var linkOrigin = link.origin || link.protocol + '//' + link.host;
	var isSameOrigin = linkOrigin == location.origin;
	if ( !isSameOrigin ) {
		console.error( '[InfiniteScroll] cannot set history with different origin: ' +
			link.origin + ' on ' + location.origin +
			' . History behavior disabled.' );
		return;
	}

	// two ways to handle changing history
	if ( this.options.append ) {
		this.createHistoryAppend();
	} else {
		this.createHistoryPageLoad();
	}
};

proto.createHistoryAppend = function() {
	this.updateMeasurements();
	this.updateScroller();
	// array of scroll positions of appended pages
	this.scrollPages = [
		{
			// first page
			top: 0,
			path: location.href,
			title: document.title,
		}
	];
	this.scrollPageIndex = 0;
	// events
	this.scrollHistoryHandler = this.onScrollHistory.bind( this );
	this.unloadHandler = this.onUnload.bind( this );
	this.scroller.addEventListener( 'scroll', this.scrollHistoryHandler );
	this.on( 'append', this.onAppendHistory );
	this.bindHistoryAppendEvents( true );
};

proto.bindHistoryAppendEvents = function( isBind ) {
	var addRemove = isBind ? 'addEventListener' : 'removeEventListener';
	this.scroller[ addRemove ]( 'scroll', this.scrollHistoryHandler );
	window[ addRemove ]( 'unload', this.unloadHandler );
};

proto.createHistoryPageLoad = function() {
	this.on( 'load', this.onPageLoadHistory );
};

InfiniteScroll.destroy.history =
proto.destroyHistory = function() {
	var isHistoryAppend = this.options.history && this.options.append;
	if ( isHistoryAppend ) {
		this.bindHistoryAppendEvents( false );
	}
};

// ----- append history ----- //

proto.onAppendHistory = function( response, path, items ) {
	var firstItem = items[0];
	var elemScrollY = this.getElementScrollY( firstItem );
	// resolve path
	link.href = path;
	// add page data to hash
	this.scrollPages.push({
		top: elemScrollY,
		path: link.href,
		title: response.title,
	});
};

proto.getElementScrollY = function( elem ) {
	if ( this.options.elementScroll ) {
		return this.getElementElementScrollY( elem );
	} else {
		return this.getElementWindowScrollY( elem );
	}
};

proto.getElementWindowScrollY = function( elem ) {
	var rect = elem.getBoundingClientRect();
	return rect.top + window.pageYOffset;
};

// wow, stupid name
proto.getElementElementScrollY = function( elem ) {
	return elem.offsetTop - this.top;
};

proto.onScrollHistory = function() {
	// cycle through positions, find biggest without going over
	var scrollViewY = this.getScrollViewY();
	var pageIndex, page;
	for ( var i=0; i < this.scrollPages.length; i++ ) {
		var scrollPage = this.scrollPages[i];
		if ( scrollPage.top >= scrollViewY ) {
			break;
		}
		pageIndex = i;
		page = scrollPage;
	}
	// set history if changed
	if ( pageIndex != this.scrollPageIndex ) {
		this.scrollPageIndex = pageIndex;
		this.setHistory( page.title, page.path );
	}
};

utils.debounceMethod( InfiniteScroll, 'onScrollHistory', 150 );

proto.getScrollViewY = function() {
	if ( this.options.elementScroll ) {
		return this.scroller.scrollTop + this.scroller.clientHeight/2;
	} else {
		return window.pageYOffset + this.windowHeight/2;
	}
};

proto.setHistory = function( title, path ) {
	var optHistory = this.options.history;
	var historyMethod = optHistory && history[ optHistory + 'State' ];
	if ( !historyMethod ) {
		return;
	}

	history[ optHistory + 'State' ]( null, title, path );

	if ( this.options.historyTitle ) {
		document.title = title;
	}

	this.dispatchEvent( 'history', null, [ title, path ] );
};

// scroll to top to prevent initial scroll-reset after page refresh
// http://stackoverflow.com/a/18633915/182183
proto.onUnload = function() {
	var pageIndex = this.scrollPageIndex;
	if ( pageIndex === 0 ) {
		return;
	}
	// calculate where scroll position would be on refresh
	var scrollPage = this.scrollPages[ pageIndex ];
	var scrollY = window.pageYOffset - scrollPage.top + this.top;
	// disable scroll event before setting scroll #679
	this.destroyHistory();
	scrollTo( 0, scrollY );
};

// ----- load history ----- //

// update URL
proto.onPageLoadHistory = function( response, path ) {
	this.setHistory( response.title, path );
};

// --------------------------  -------------------------- //

return InfiniteScroll;

}));

// button
( function( window, factory ) {
	// universal module definition
	/* globals define, module, require */
	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define( 'infinite-scroll/js/button',[
			'./core',
			'fizzy-ui-utils/utils',
		], function( InfiniteScroll, utils ) {
			return factory( window, InfiniteScroll, utils );
		});
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory(
			window,
			require('./core'),
			require('fizzy-ui-utils')
		);
	} else {
		// browser global
		factory(
			window,
			window.InfiniteScroll,
			window.fizzyUIUtils
		);
	}

}( window, function factory( window, InfiniteScroll, utils ) {

// InfiniteScroll.defaults.button = null;

InfiniteScroll.create.button = function() {
	var buttonElem = utils.getQueryElement( this.options.button );
	if ( buttonElem ) {
		this.button = new InfiniteScrollButton( buttonElem, this );
		return;
	}
};

InfiniteScroll.destroy.button = function() {
	if ( this.button ) {
		this.button.destroy();
	}
};

// -------------------------- InfiniteScrollButton -------------------------- //

function InfiniteScrollButton( element, infScroll ) {
	this.element = element;
	this.infScroll = infScroll;
	// events
	this.clickHandler = this.onClick.bind( this );
	this.element.addEventListener( 'click', this.clickHandler );
	infScroll.on( 'request', this.disable.bind( this ) );
	infScroll.on( 'load', this.enable.bind( this ) );
	infScroll.on( 'error', this.hide.bind( this ) );
	infScroll.on( 'last', this.hide.bind( this ) );
}

InfiniteScrollButton.prototype.onClick = function( event ) {
	event.preventDefault();
	this.infScroll.loadNextPage();
};

InfiniteScrollButton.prototype.enable = function() {
	this.element.removeAttribute('disabled');
};

InfiniteScrollButton.prototype.disable = function() {
	this.element.disabled = 'disabled';
};

InfiniteScrollButton.prototype.hide = function() {
	this.element.style.display = 'none';
};

InfiniteScrollButton.prototype.destroy = function() {
	this.element.removeEventListener( 'click', this.clickHandler );
};

// --------------------------  -------------------------- //

InfiniteScroll.Button = InfiniteScrollButton;

return InfiniteScroll;

}));

// status
( function( window, factory ) {
	// universal module definition
	/* globals define, module, require */
	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define( 'infinite-scroll/js/status',[
			'./core',
			'fizzy-ui-utils/utils',
		], function( InfiniteScroll, utils ) {
			return factory( window, InfiniteScroll, utils );
		});
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory(
			window,
			require('./core'),
			require('fizzy-ui-utils')
		);
	} else {
		// browser global
		factory(
			window,
			window.InfiniteScroll,
			window.fizzyUIUtils
		);
	}

}( window, function factory( window, InfiniteScroll, utils ) {

var proto = InfiniteScroll.prototype;

// InfiniteScroll.defaults.status = null;

InfiniteScroll.create.status = function() {
	var statusElem = utils.getQueryElement( this.options.status );
	if ( !statusElem ) {
		return;
	}
	// elements
	this.statusElement = statusElem;
	this.statusEventElements = {
		request: statusElem.querySelector('.infinite-scroll-request'),
		error: statusElem.querySelector('.infinite-scroll-error'),
		last: statusElem.querySelector('.infinite-scroll-last'),
	};
	// events
	this.on( 'request', this.showRequestStatus );
	this.on( 'error', this.showErrorStatus );
	this.on( 'last', this.showLastStatus );
	this.bindHideStatus('on');
};

proto.bindHideStatus = function( bindMethod ) {
	var hideEvent = this.options.append ? 'append' : 'load';
	this[ bindMethod ]( hideEvent, this.hideAllStatus );
};

proto.showRequestStatus = function() {
	this.showStatus('request');
};

proto.showErrorStatus = function() {
	this.showStatus('error');
};

proto.showLastStatus = function() {
	this.showStatus('last');
	// prevent last then append event race condition from showing last status #706
	this.bindHideStatus('off');
};

proto.showStatus = function( eventName ) {
	show( this.statusElement );
	this.hideStatusEventElements();
	var eventElem = this.statusEventElements[ eventName ];
	show( eventElem );
};

proto.hideAllStatus = function() {
	hide( this.statusElement );
	this.hideStatusEventElements();
};

proto.hideStatusEventElements = function() {
	for ( var type in this.statusEventElements ) {
		var eventElem = this.statusEventElements[ type ];
		hide( eventElem );
	}
};

// --------------------------  -------------------------- //

function hide( elem ) {
	setDisplay( elem, 'none' );
}

function show( elem ) {
	setDisplay( elem, 'block' );
}

function setDisplay( elem, value ) {
	if ( elem ) {
		elem.style.display = value;
	}
}

// --------------------------  -------------------------- //

return InfiniteScroll;

}));

/*!
 * Infinite Scroll v3.0.3
 * Automatically add next page
 *
 * Licensed GPLv3 for open source use
 * or Infinite Scroll Commercial License for commercial use
 *
 * https://infinite-scroll.com
 * Copyright 2018 Metafizzy
 */

( function( window, factory ) {
	// universal module definition
	/* globals define, module, require */
	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define( [
			'infinite-scroll/js/core',
			'infinite-scroll/js/page-load',
			'infinite-scroll/js/scroll-watch',
			'infinite-scroll/js/history',
			'infinite-scroll/js/button',
			'infinite-scroll/js/status',
		], factory );
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory(
			require('./core'),
			require('./page-load'),
			require('./scroll-watch'),
			require('./history'),
			require('./button'),
			require('./status')
		);
	}

})( window, function factory( InfiniteScroll ) {
	return InfiniteScroll;
});

/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
	// universal module definition

	/*global define: false, module: false, require: false */

	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define( 'imagesloaded/imagesloaded',[
			'ev-emitter/ev-emitter'
		], function( EvEmitter ) {
			return factory( window, EvEmitter );
		});
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory(
			window,
			require('ev-emitter')
		);
	} else {
		// browser global
		window.imagesLoaded = factory(
			window,
			window.EvEmitter
		);
	}

})( typeof window !== 'undefined' ? window : this,

// --------------------------  factory -------------------------- //

function factory( window, EvEmitter ) {



var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
	for ( var prop in b ) {
		a[ prop ] = b[ prop ];
	}
	return a;
}

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
function makeArray( obj ) {
	if ( Array.isArray( obj ) ) {
		// use object if already an array
		return obj;
	}

	var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
	if ( isArrayLike ) {
		// convert nodeList to array
		return arraySlice.call( obj );
	}

	// array of single index
	return [ obj ];
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */
function ImagesLoaded( elem, options, onAlways ) {
	// coerce ImagesLoaded() without new, to be new ImagesLoaded()
	if ( !( this instanceof ImagesLoaded ) ) {
		return new ImagesLoaded( elem, options, onAlways );
	}
	// use elem as selector string
	var queryElem = elem;
	if ( typeof elem == 'string' ) {
		queryElem = document.querySelectorAll( elem );
	}
	// bail if bad element
	if ( !queryElem ) {
		console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
		return;
	}

	this.elements = makeArray( queryElem );
	this.options = extend( {}, this.options );
	// shift arguments if no options set
	if ( typeof options == 'function' ) {
		onAlways = options;
	} else {
		extend( this.options, options );
	}

	if ( onAlways ) {
		this.on( 'always', onAlways );
	}

	this.getImages();

	if ( $ ) {
		// add jQuery Deferred object
		this.jqDeferred = new $.Deferred();
	}

	// HACK check async to allow time to bind listeners
	setTimeout( this.check.bind( this ) );
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.options = {};

ImagesLoaded.prototype.getImages = function() {
	this.images = [];

	// filter & find items if we have an item selector
	this.elements.forEach( this.addElementImages, this );
};

/**
 * @param {Node} element
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
	// filter siblings
	if ( elem.nodeName == 'IMG' ) {
		this.addImage( elem );
	}
	// get background image on element
	if ( this.options.background === true ) {
		this.addElementBackgroundImages( elem );
	}

	// find children
	// no non-element nodes, #143
	var nodeType = elem.nodeType;
	if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
		return;
	}
	var childImgs = elem.querySelectorAll('img');
	// concat childElems to filterFound array
	for ( var i=0; i < childImgs.length; i++ ) {
		var img = childImgs[i];
		this.addImage( img );
	}

	// get child background images
	if ( typeof this.options.background == 'string' ) {
		var children = elem.querySelectorAll( this.options.background );
		for ( i=0; i < children.length; i++ ) {
			var child = children[i];
			this.addElementBackgroundImages( child );
		}
	}
};

var elementNodeTypes = {
	1: true,
	9: true,
	11: true
};

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
	var style = getComputedStyle( elem );
	if ( !style ) {
		// Firefox returns null if in a hidden iframe https://bugzil.la/548397
		return;
	}
	// get url inside url("...")
	var reURL = /url\((['"])?(.*?)\1\)/gi;
	var matches = reURL.exec( style.backgroundImage );
	while ( matches !== null ) {
		var url = matches && matches[2];
		if ( url ) {
			this.addBackground( url, elem );
		}
		matches = reURL.exec( style.backgroundImage );
	}
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
	var loadingImage = new LoadingImage( img );
	this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
	var background = new Background( url, elem );
	this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
	var _this = this;
	this.progressedCount = 0;
	this.hasAnyBroken = false;
	// complete if no images
	if ( !this.images.length ) {
		this.complete();
		return;
	}

	function onProgress( image, elem, message ) {
		// HACK - Chrome triggers event before object properties have changed. #83
		setTimeout( function() {
			_this.progress( image, elem, message );
		});
	}

	this.images.forEach( function( loadingImage ) {
		loadingImage.once( 'progress', onProgress );
		loadingImage.check();
	});
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
	this.progressedCount++;
	this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
	// progress event
	this.emitEvent( 'progress', [ this, image, elem ] );
	if ( this.jqDeferred && this.jqDeferred.notify ) {
		this.jqDeferred.notify( this, image );
	}
	// check if completed
	if ( this.progressedCount == this.images.length ) {
		this.complete();
	}

	if ( this.options.debug && console ) {
		console.log( 'progress: ' + message, image, elem );
	}
};

ImagesLoaded.prototype.complete = function() {
	var eventName = this.hasAnyBroken ? 'fail' : 'done';
	this.isComplete = true;
	this.emitEvent( eventName, [ this ] );
	this.emitEvent( 'always', [ this ] );
	if ( this.jqDeferred ) {
		var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
		this.jqDeferred[ jqMethod ]( this );
	}
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
	this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
	// If complete is true and browser supports natural sizes,
	// try to check for image status manually.
	var isComplete = this.getIsImageComplete();
	if ( isComplete ) {
		// report based on naturalWidth
		this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
		return;
	}

	// If none of the checks above matched, simulate loading on detached element.
	this.proxyImage = new Image();
	this.proxyImage.addEventListener( 'load', this );
	this.proxyImage.addEventListener( 'error', this );
	this.img.addEventListener( 'load', this );
	this.img.addEventListener( 'error', this );
	this.proxyImage.src = this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
	return this.img.complete && this.img.naturalWidth;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
	this.isLoaded = isLoaded;
	this.emitEvent( 'progress', [ this, this.img, message ] );
};

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
	var method = 'on' + event.type;
	if ( this[ method ] ) {
		this[ method ]( event );
	}
};

LoadingImage.prototype.onload = function() {
	this.confirm( true, 'onload' );
	this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
	this.confirm( false, 'onerror' );
	this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
	this.proxyImage.removeEventListener( 'load', this );
	this.proxyImage.removeEventListener( 'error', this );
	this.img.removeEventListener( 'load', this );
	this.img.removeEventListener( 'error', this );
};

function Background( url, element ) {
	this.url = url;
	this.element = element;
	this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
	this.img.addEventListener( 'load', this );
	this.img.addEventListener( 'error', this );
	this.img.src = this.url;
	// check if image is already complete
	var isComplete = this.getIsImageComplete();
	if ( isComplete ) {
		this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
		this.unbindEvents();
	}
};

Background.prototype.unbindEvents = function() {
	this.img.removeEventListener( 'load', this );
	this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
	this.isLoaded = isLoaded;
	this.emitEvent( 'progress', [ this, this.element, message ] );
};

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
	jQuery = jQuery || window.jQuery;
	if ( !jQuery ) {
		return;
	}
	// set local variable
	$ = jQuery;
	// $().imagesLoaded()
	$.fn.imagesLoaded = function( options, callback ) {
		var instance = new ImagesLoaded( this, options, callback );
		return instance.jqDeferred.promise( $(this) );
	};
};

ImagesLoaded.makeJQueryPlugin();

return ImagesLoaded;
});

var imglgH;
var imglgW;

$(document).ready(function(){
	initColorBox();

	// init Infinite Scroll
	
	setTimeout(function(){
		initInfiniteScroll();
		getFilterAmounts();
	}, 0);

	$(".cb_filter").change(function() {
		resetSearchResult();
	});
	$(document).on('click', '#addon-search', function(e) {
		e.preventDefault();
		resetSearchResult();
	});
	$(document).on('keypress', '#search', function(e) {
		if (e.keyCode == 13) { resetSearchResult(); }
	});

	switchLanguage(getPreferredLanguage());

	$('.carousel').carousel({
		interval: 10000
	});
	
	setWHVars();
	
	$( window ).resize(function() {
		setWHVars();
	});
	$(document).on('click', '.result:not(.no-results)', function(e) {
		e.preventDefault();
		openProduct($(this));
	});
	$(document).on('click', '.imgsm', function(e) {
		if (MOBILE)
		{
			e.preventDefault();
			$(".imglg").empty();
	
			var vid						= JSO.toString($(this).data("vidurl")) != "";
			
			if (vid)
			{
				if (!$(".imglg").hasClass("vid"))	{ $(".imglg").addClass("vid"); }
				
				$(".imglg").css('background-image', "");
				$(".imglg").attr('title', $(this).attr("title"));
				$(".imglg").append('<iframe width="' + imglgW + '" height="' + imglgH + '" src="' + $(this).data("vidurl") + '" frameborder="0" allowfullscreen=""></iframe>');
				initColorBox();
			}
			else
			{
				if ($(".imglg").hasClass("vid"))	{ $(".imglg").removeClass("vid"); }
				
				$(".imglg").css('background-image', $(this).css('background-image').replace(/\/resize\/\d+x\d+/gi, ""));
				$(".imglg").attr('title', $(this).attr("title"));
				$(".imglg").append('<a class="colorbox" src="' + $("a.colorbox", $(this)).attr("href") + '" title="' + $(this).attr("title") + '"></a>');
				initColorBox();
			}
		}
	});
});

function initInfiniteScroll()
{
	try
	{
		var $grid				= $('.results');

		if ($grid.length > 0)
		{
			$grid.infiniteScroll({
				path: function() {
					return $(".pagination__next").last().attr("href");
				},
				checkLastPage: '.pagination__next',
				append: '.result',
				history: false,
				status: '.scroll-load-status',
				scrollThreshold: 800,
				prefill: true,
				usepost: true
			});

			$grid.on('last.infiniteScroll', function(event, response, path) { $(".scroll-load-status").remove(); });
		}
	}
	catch (ex)					{ /* no problem */ }
}

function initColorBox()
{
	try { $.colorbox.remove("a.thickbox, a.colorbox, area.colorbox, input.colorbox, a.colorboxvid"); } catch (e) { /*no problem*/ }
	try
	{
		if (MOBILE)				{ $("a.thickbox, a.colorbox, area.colorbox, input.colorbox").attr("target", "_blank"); }
		else
		{
			$("a.thickbox, a.colorbox, area.colorbox, input.colorbox").colorbox({ maxWidth:'95%', maxHeight:'95%', rel:'gal' });
			$("a.colorboxvid").colorbox({ width:'600px', height:'400px', rel:'gal', iframe: true });
		}
	}
	catch (ex)					{ /*no problem*/ }
}

function resetSearchResult()
{
	var $grid				= $('.results');
	$grid.infiniteScroll('destroy');
	$grid.data('infiniteScroll', null);

	$grid.empty();
	$grid.html("<a class=\"pagination__next\" href=\"/jsp/ducker/searchc.jsp?domcod=" + $grid.data("domcod") + "&page=0\"></a>");

	initInfiniteScroll();
	getFilterAmounts();
}

function setWHVars()
{
	if ($(".imglg").length)
	{
		imglgH					= $(".imglg").outerHeight();
		imglgW					= $(".imglg").outerWidth();
	}
}

function getPreferredLanguage()
{
	var storedLanguage			= localStorage.getItem('language');

	if (storedLanguage)			{ return storedLanguage; }
	else						{ return navigator.language || navigator.userLanguage; }
}

function switchLanguage(language)
{
	var dash					= language.indexOf("-");
	var language				= dash > 0 ? language.substring(0, dash) : language;

	if ($('#language-' + language).length == 0) { language = "nl"; }

	$('.current-language').each(function() {
		this.className = $('#language-' + language + " .flag")[0].className;
		$(this).css('visibility', 'visible');
	});

	localStorage.setItem('language', language);

	$.post("/language", { "language" :  language }, function(data){
		var response = jQuery.parseJSON(data);

		if (response.changed)	{ window.location.reload(); }
	});
}

function getInfiniteScrollPostJSONParams()
{
	var filters					= {};
	var search					= $("#search").val();
	var tmp;

	$( ".cb_filter:checked" ).each(function( index )
	{
		tmp						= filters[$(this).attr("name")];

		if (!tmp)				{ tmp = []; }

		tmp.push($(this).val());

		filters[$(this).attr("name")] = tmp;
	});

	return JSON.stringify({"filters": filters, "search": search});
}

function getFilterAmounts()
{
	$.ajax({
		type: "POST",
		url: "/FunctionsServlet?action=nres&domcod=" + $('.results').data("domcod"),
		data: getInfiniteScrollPostJSONParams(),
		contentType: 'application/json',
		success: function( data ) {
			var tmp, tmpval;
			$("#filter_categories .form-check-label span.nres").each(function( index )
			{
				tmp					= $(this).parent().get(0).htmlFor.right("_");
				tmpval				= JSO.toInt(data.vrdsrtcods["" + tmp]);

				if (tmpval == 0)	{ $(this).text(""); }
				else				{ $(this).text("(" + tmpval + ")"); }
			});
			$("#filter_makes .form-check-label span.nres").each(function( index )
			{
				tmp					= $(this).parent().get(0).htmlFor.right("_");
				tmpval				= JSO.toInt(data.merken["" + tmp]);

				if (tmpval == 0)	{ $(this).text(""); }
				else				{ $(this).text("(" + tmpval + ")"); }
			});
			$("#filter_structures .form-check-label span.nres").each(function( index )
			{
				tmp					= $(this).parent().get(0).htmlFor.right("_");
				tmpval				= JSO.toInt(data.opbouwen["" + tmp]);

				if (tmpval == 0)	{ $(this).text(""); }
				else				{ $(this).text("(" + tmpval + ")"); }
			});
		}
	});
}

function openProduct(item)
{
	if (JSO.toString($(item).data("purl")) != "")	{ window.location.href = $(item).data("purl"); }
	else											{ window.location.href = "/product/a" + JSO.toInt($(item).data("vrdunid")) + ".html"; }
}

